var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.legendHtml)?_c('div',{staticClass:"leyend-p",domProps:{"innerHTML":_vm._s(_vm.legendHtml)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }